// extracted by mini-css-extract-plugin
export default {"centered":"CenteredPageLayout_centered__5+e+K"};